import { Tag } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

function TagStatus({
  onClick,
  selected,
  children,
}: {
  onClick: () => any;
  selected: boolean;
  children: React.ReactNode;
}) {
  return (
    <Tag
      bg={selected ? colors.blue500 : colors.lightGray}
      color={selected ? colors.white : colors.black}
      borderRadius={20}
      mr={2}
      mb={2}
      p={2}
      _hover={{
        background: `${colors.blue500}`,
        color: `${colors.white}`,
      }}
      transition="all 0.3s"
      onClick={onClick}
      cursor="pointer"
      fontWeight="normal"
    >
      {children}
    </Tag>
  );
}

export default TagStatus;
